import axiosInstance from "../../../../api/axiosConfig";

export const addCustomers = (data: any) => {
  return axiosInstance.post("/admin/companies", data);
};

export const getCustomers = (id: string) => {
  return axiosInstance.get(`/admin/companies/${id}`);
};

export const updateCustomers = (id: string, data: any) => {
  return axiosInstance.patch(`/admin/companies/${id}`, data);
};

export const getCountries = (params: any) => {
  return axiosInstance.get("/admin/countries", { params });
};
